import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { OutlineEye, OutlineEyeOff } from "./assets";
import GenericModal from "./GenericModal";
import ModalProfilethree from "./ModalProfilethree";
import ModalUpdateSuccess from "./ModalUpdateSuccess";
import PaymentDetails from "./PaymentDetails";
import { checkAuthStatus, logoutUser } from "./redux/slices/authThunks";
import {
  updateMembersItem,
  updateMembersPass,
} from "./redux/slices/MembersThunks";
import { uploadImage } from "./redux/slices/VendorThunks";
import { formatDate, UK_PHONE_REGEX } from "./utils/func";
import { isValidEmail } from "./utils/regex";

export default function Profileone() {
  const dispatch = useDispatch();
  const location = useLocation();
  // State management
  const [activeItem, setActiveItem] = useState("general");
  const [previousItem, setPreviousItem] = useState(null);
  const [navigationStack, setNavigationStack] = useState([]);

  const member = JSON.parse(localStorage.getItem("member"));
  const user = JSON.parse(localStorage.getItem("user"));
  const [editMember, setEditMember] = useState(member);
  const [oldEditMember, setOldEditMember] = useState(user);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");

  // Error states
  const [passwordError, setPasswordError] = useState("");
  const [generalError, setGeneralError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // Modal states
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  // Form data and other states
  const images = [
    "https://d3nakrlcog1u3z.cloudfront.net/1749727331461-4ba31f443c5925758c3d2520e8dd101288b7e192.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727392815-8f2345c2608775537665ca7281faf60fab660156.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727414680-96ad668930fe16e86e392dba572555141803ed35.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1752658904265-inspectorowl.png",
    "https://d3nakrlcog1u3z.cloudfront.net/1749727454290-f2eff8c225ba3e0f76746b5e4d09bbc23a4e177a.png",
  ];
  const [selectedImage, setSelectedImage] = useState(user?.profile_picture);
  const [showPassword, setshowPassword] = useState(false);
  const [showNewpass, setshowNewpass] = useState(false);
  const [prevEmailAddess, setPrevEmail] = useState(member?.email_address);
  const [memberUpdated, setMemberUpdated] = useState(false);
  const { account, loading, error } = useSelector((state) => state.members);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    accountHolderName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscSwiftCode: "",
    dateOfBirth: "",
    streetAddress: "",
    postalCode: "",
    nationalInsuranceNumber: "",
  });
  const [initialFormData, setInitialFormData] = useState({});
  const navigate = useNavigate();

  const handleActiveChange = (item) => {
    setNavigationStack((prev) => [...prev, activeItem]);
    setActiveItem(item);
  };
  const goBack = () => {
    if (navigationStack.length > 0) {
      const newStack = [...navigationStack];
      const previousItem = newStack.pop();
      setNavigationStack(newStack);
      setActiveItem(previousItem);
    } else {
      navigate(-1);
    }
  };

  const clearAllErrors = () => {
    setGeneralError("");
    setPasswordError("");
  };

  const openModal = () => setIsModalOpen(true);
  const openSuccessModal = () => setIsSuccessModalOpen(true);
  const closeSuccessModal = () => setIsSuccessModalOpen(false);
  const closeModal = () => {
    setIsModalOpen(false);
    setActiveItem("general");
  };

  function isValidPassword(password) {
    const regex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    return regex.test(password);
  }

  // Validate UK phone number
  const isValidUKPhone = (phoneNumber) => {
    try {
      return UK_PHONE_REGEX.test(phoneNumber.replace(/\s/g, ""));
    } catch (error) {
      console.error("Phone validation error:", error);
      return false;
    }
  };

  const handleFieldChange = async (key, value) => {
    setIsLoading(true);
    clearAllErrors();

    try {
      const res = await dispatch(uploadImage(value));

      if (res?.payload?.fileURL) {
        setSelectedImage(res.payload.fileURL);
        setEditMember((prev) => ({
          ...prev,
          [key]: res.payload.fileURL,
        }));
      } else {
        throw new Error("Failed to upload image: No file URL returned");
      }
    } catch (error) {
      console.error("Image upload error:", error);
      setGeneralError("Failed to upload image. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const editHandler = async () => {
    setIsLoading(true);
    clearAllErrors();
    setHasSubmitted(true);

    try {
      // Validation
      if (!editMember?.first_name?.trim()) {
        throw new Error("First name is required");
      }

      if (!editMember?.last_name?.trim()) {
        throw new Error("Last name is required");
      }

      // Usage
      const trimmedEmail = editMember?.email_address?.trim() || "";
      if (!isValidEmail(trimmedEmail)) {
        throw new Error("Invalid email format.");
      }

      if (!editMember?.phone_number?.trim()) {
        throw new Error("Phone number is required");
      }

      // Validate phone number format
      if (!isValidUKPhone(editMember.phone_number)) {
        throw new Error("Please enter a valid UK phone number.");
      }

      const prevEmail = prevEmailAddess;
      const newEmail = editMember?.email_address;

      const payload = {
        ...editMember,
      };

      const updatedMember = await dispatch(updateMembersItem(payload)).unwrap();

      try {
        const data = JSON.stringify(editMember);
        localStorage.setItem("member", data);
      } catch (storageError) {
        console.error("localStorage error:", storageError);
      }

      setOldEditMember(updatedMember);

      if (prevEmail !== newEmail) {
        openSuccessModal();
        try {
          localStorage.removeItem("member");
          localStorage.removeItem("user");
          await dispatch(logoutUser());
          window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        } catch (logoutError) {
          console.error("Logout error:", logoutError);
          setGeneralError(
            "Profile updated but logout failed. Please refresh the page."
          );
        }
        return;
      }

      openSuccessModal();
    } catch (error) {
      console.error("Edit member failed:", error);
      const errorMessage =
        error?.message ||
        error?.payload?.message ||
        "Failed to update profile. Please try again.";
      setGeneralError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  const updateProfilePicture = async () => {
    setIsLoading(true);
    clearAllErrors();
    setHasSubmitted(true);

    try {
      const updatedMember = await dispatch(
        updateMembersItem(editMember)
      ).unwrap();

      // Update localStorage safely
      try {
        const data = JSON.stringify(editMember);
        localStorage.setItem("member", data);
      } catch (storageError) {
        console.error("localStorage error:", storageError);
      }

      setOldEditMember(updatedMember);

      openSuccessModal();
    } catch (error) {
      console.error("Edit member failed:", error);
      const errorMessage =
        error?.message ||
        error?.payload?.message ||
        "Failed to update profile. Please try again.";
      setGeneralError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePassword = async () => {
    setIsLoading(true);
    clearAllErrors();
    try {
      // Validation
      if (!oldPassword.trim()) {
        throw new Error("Old password is required");
      }

      if (!newPassword.trim()) {
        throw new Error("New password is required");
      }

      if (!isValidPassword(newPassword)) {
        throw new Error(
          "Password must be at least 8 characters with a mix of letters & numbers."
        );
      }

      if (oldPassword === newPassword) {
        throw new Error("New password must be different from the old password");
      }

      const data = {
        oldPassword,
        newPassword,
      };

      await dispatch(updateMembersPass(data)).unwrap();
      setOldPassword("");
      setNewPassword("");

      openSuccessModal();
    } catch (error) {
      console.error("Error updating password:", error);
      const errorMessage =
        error?.message ||
        error?.payload?.message ||
        "Failed to update password. Please try again.";
      setPasswordError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (memberUpdated) {
      try {
        dispatch(checkAuthStatus());
        setMemberUpdated(false);
      } catch (error) {
        console.error("Auth status check failed:", error);
      }
    }
  }, [memberUpdated, dispatch]);

  useEffect(() => {
    setInitialFormData(formData);
  }, []);

  const ErrorDisplay = ({ error, onClear }) => {
    if (!error) return null;

    return (
      <div
        style={{
          color: "#dc2626",
          marginBottom: "16px",
          display: "flex",
          alignItems: "center",
          fontFamily: "Montserrat",
          width: "100%",
          textAlign: "left",
          fontSize: "14px",
          // backgroundColor: "#fef2f2",
          // padding: "12px",
          // borderRadius: "6px",
          // border: "1px solid #fecaca",
        }}
      >
        <span>{error}</span>
        {onClear && <></>}
      </div>
    );
  };
  useEffect(() => {
    if (location.state?.activeItem) {
      setActiveItem(location.state.activeItem);
    }
  }, [location.state]);
  return (
    <RootWrapperProfileone>
      <Dashboard>
        <Wrapper>
          {member?.stripe_account_id === null &&
            member?.member_type === "Individual" && (
              <Frame1466>
                <Frame1428>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 25H27.5V27.5H2.5V25ZM5 15H7.5V23.75H5V15ZM11.25 15H13.75V23.75H11.25V15ZM16.25 15H18.75V23.75H16.25V15ZM22.5 15H25V23.75H22.5V15ZM2.5 8.75L15 2.5L27.5 8.75V13.75H2.5V8.75ZM5 10.295V11.25H25V10.295L15 5.295L5 10.295ZM15 10C14.6685 10 14.3505 9.8683 14.1161 9.63388C13.8817 9.39946 13.75 9.08152 13.75 8.75C13.75 8.41848 13.8817 8.10054 14.1161 7.86612C14.3505 7.6317 14.6685 7.5 15 7.5C15.3315 7.5 15.6495 7.6317 15.8839 7.86612C16.1183 8.10054 16.25 8.41848 16.25 8.75C16.25 9.08152 16.1183 9.39946 15.8839 9.63388C15.6495 9.8683 15.3315 10 15 10Z"
                      fill="#5954DE"
                    />
                  </svg>
                </Frame1428>
                <Frame1468>
                  <p>
                    Complete payment details to set up your Stripe account and
                    start receiving payments.
                  </p>
                </Frame1468>
              </Frame1466>
            )}
          <Frame1503>
            <img
              src={oldEditMember?.profile_picture}
              width={153}
              height={153}
              style={{
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "200px",
              }}
              alt=""
            />
            <Frame1494>
              <JamesDoe>
                {member?.first_name + " " + member?.last_name}
              </JamesDoe>
              <IndividualMember>{member?.member_type} Member</IndividualMember>
              <MemberSince01Mar2025>
                Member Since: {formatDate(user?.created_at)}
              </MemberSince01Mar2025>
            </Frame1494>
          </Frame1503>

          <Frame1502>
            <PRTNR.SidebarNav
              activeItem={activeItem}
              onItemClick={(item) => {
                handleActiveChange(item);
                if (item === "delete-account") {
                  openModal();
                }
              }}
              stripeAccountId={member?.stripe_account_id}
            />
            {activeItem == "general" && (
              <>
                {member?.member_type == "Enterprise" ? (
                  <>
                    {" "}
                    <Frame1501>
                      <Frame1496>
                        <GeneralInformation>
                          General Information
                        </GeneralInformation>
                        <Frame1502>
                          <PRTNR.Input
                            label="First name"
                            value={editMember?.first_name}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                first_name: e.target.value,
                              });
                            }}
                          />

                          <PRTNR.Input
                            label="Last name"
                            value={editMember?.last_name}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                last_name: e.target.value,
                              });
                            }}
                          />
                        </Frame1502>

                        <PRTNR.Input
                          label="Work Email Address"
                          value={editMember?.email_address}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              email_address: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Input
                          label="Phone"
                          type="number"
                          value={editMember.phone_number}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              phone_number: e.target.value,
                            });
                          }}
                          require
                          // error={hasSubmitted && !editMember.phone_number}
                          errorMessage={"Required Field"}
                          style={{ MozAppearance: "textfield" }} // Firefox fallback
                        />

                        <Frame1502>
                          <PRTNR.Input
                            label="Job Title"
                            value={editMember?.job_title}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                job_title: e.target.value,
                              });
                            }}
                          />

                          <PRTNR.Select
                            label="Seniority"
                            value={editMember?.seniority}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                seniority: e.target.value,
                              });
                            }}
                            options={[
                              { value: "C-level", label: "C-level" },
                              { value: "Consultant", label: "Consultant" },
                              {
                                value: "Senior Management",
                                label: "Senior Management",
                              },
                              { value: "Manager", label: "Manager" },
                              { value: "Assistant", label: "Assistant" },
                              {
                                value: "Junior Professional",
                                label: "Junior Professional",
                              },
                            ]}
                          />
                        </Frame1502>
                        <Frame1502>
                          <PRTNR.Input
                            label="City"
                            value={editMember?.city}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                city: e.target.value,
                              });
                            }}
                          />

                          <PRTNR.Select
                            label="Country of Residence"
                            value={editMember?.country_of_residence}
                            options={[
                              {
                                value: "United Kingdom",
                                label: "United Kingdom",
                              },
                            ]}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                country_of_residence: e.target.value,
                              });
                            }}
                          />
                        </Frame1502>
                        <BusinessInformation>
                          Business Information
                        </BusinessInformation>

                        <PRTNR.Input
                          label="Company Name"
                          value={editMember?.company_name}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              company_name: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Input
                          label="Company Website"
                          value={editMember?.company_website_url}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              company_website_url: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Input
                          id="companyAddress"
                          name="companyAddress"
                          label="Company Address"
                          value={editMember?.company_address}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              company_address: e.target.value,
                            });
                          }}
                        />

                        <Frame1502>
                          <PRTNR.Input
                            label="Company no"
                            value={editMember?.company_no}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                company_no: e.target.value,
                              });
                            }}
                          />

                          <PRTNR.Input
                            label="Tax identification number"
                            value={editMember?.tax_identification_no}
                            onChange={(e) => {
                              setEditMember({
                                ...editMember,
                                tax_identification_no: e.target.value,
                              });
                            }}
                          />
                        </Frame1502>
                        {/* <Frame1502>
                          <PRTNR.Input label="Country Issuing Tax Identification Number" />
                        </Frame1502> */}
                        <Frame1502>
                          <PRTNR.Select
                            label="Is your company a UK partnership?"
                            value={editMember?.is_uk_registered ? "Yes" : "No"}
                            onChange={(e) => {
                              const isUKRegistered = e.target.value === "Yes"; // true if "Yes", false if "No"
                              setEditMember({
                                ...editMember,
                                is_uk_registered: isUKRegistered,
                              });
                            }}
                            options={[
                              {
                                value: "Yes",
                                label: "Yes",
                              },
                              {
                                value: "No",
                                label: "No",
                              },
                            ]}
                          />
                        </Frame1502>
                      </Frame1496>
                      <Frame1502>
                        <ErrorDisplay
                          error={generalError}
                          onClear={() => setGeneralError("")}
                        />
                      </Frame1502>
                      <Frame1500>
                        <PRTNR.Button
                          variant="gray-light"
                          onClick={() => {
                            setEditMember(member);
                            goBack();
                          }}
                        >
                          Discard
                        </PRTNR.Button>

                        <Frame1399>
                          <PRTNR.Button
                            variant="black"
                            onClick={() => {
                              editHandler();
                            }}
                          >
                            {isLoading ? "Saving..." : "Save Changes"}
                          </PRTNR.Button>
                        </Frame1399>
                      </Frame1500>
                    </Frame1501>
                  </>
                ) : (
                  <Frame1501>
                    <Frame1496>
                      <Frame1502>
                        <PRTNR.Input
                          label="First Name"
                          value={editMember?.first_name}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              first_name: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Input
                          label="Last Name"
                          value={editMember?.last_name}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              last_name: e.target.value,
                            });
                          }}
                        />
                      </Frame1502>

                      <PRTNR.Input
                        label="Email Address"
                        value={editMember?.email_address}
                        onChange={(e) => {
                          setEditMember({
                            ...editMember,
                            email_address: e.target.value,
                          });
                        }}
                      />

                      <PRTNR.Input
                        label="Phone"
                        value={editMember.phone_number}
                        onChange={(e) => {
                          setEditMember({
                            ...editMember,
                            phone_number: e.target.value,
                          });
                        }}
                        required
                        // error={hasSubmitted && !editMember.phone_number}
                        errorMessage={"Required Field"}
                      />

                      <Frame1502>
                        <PRTNR.Input
                          label="Job Title"
                          value={editMember?.job_title}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              job_title: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Select
                          label="Seniority"
                          value={editMember?.seniority}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              seniority: e.target.value,
                            });
                          }}
                          options={[
                            { value: "C-level", label: "C-level" },
                            { value: "Consultant", label: "Consultant" },
                            {
                              value: "Senior Management",
                              label: "Senior Management",
                            },
                            { value: "Manager", label: "Manager" },
                            { value: "Assistant", label: "Assistant" },
                            {
                              value: "Junior Professional",
                              label: "Junior Professional",
                            },
                          ]}
                        />
                      </Frame1502>
                      <Frame1502>
                        <PRTNR.Input
                          label="City"
                          value={editMember?.city}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              city: e.target.value,
                            });
                          }}
                        />

                        <PRTNR.Select
                          label="Country of Residence"
                          value={editMember?.country_of_residence}
                          options={[
                            {
                              value: "United Kingdom",
                              label: "United Kingdom",
                            },
                          ]}
                          onChange={(e) => {
                            setEditMember({
                              ...editMember,
                              country_of_residence: e.target.value,
                            });
                          }}
                        />
                      </Frame1502>
                    </Frame1496>
                    <ErrorDisplay
                      error={generalError}
                      onClear={() => setGeneralError("")}
                    />
                    <Frame1500>
                      <PRTNR.Button
                        variant="gray-light"
                        onClick={() => {
                          setEditMember(member);
                          goBack();
                        }}
                      >
                        Discard
                      </PRTNR.Button>

                      <Frame1399>
                        <PRTNR.Button
                          variant="black"
                          onClick={() => {
                            editHandler();
                          }}
                        >
                          {isLoading ? "Saving..." : "Save Changes"}
                        </PRTNR.Button>
                      </Frame1399>
                    </Frame1500>
                  </Frame1501>
                )}
              </>
            )}
            {activeItem == "edit-picture" && (
              <Frame1501>
                <Frame1502_0001>
                  <Frame1501_0001>
                    <Profilepicture>
                      <Frame1572>
                        <Frame1572_0001>
                          <SelectAProfilePicture>
                            Select a profile picture
                          </SelectAProfilePicture>
                        </Frame1572_0001>
                      </Frame1572>
                      <Frame1570>
                        {images.map((val, idx) => {
                          return (
                            <Picture
                              onClick={() => {
                                setEditMember({
                                  ...editMember,
                                  profile_picture: val,
                                });
                                setSelectedImage(val);
                              }}
                              style={{
                                border:
                                  selectedImage == val
                                    ? "solid 2px rgba(66, 149, 254, 0.7)"
                                    : "solid 2px rgba(136, 136, 136, 0.1)",
                              }}
                            >
                              <Image21 src={val} alt="Profile Picture " />
                            </Picture>
                          );
                        })}
                      </Frame1570>
                      <>
                        <Frame1572>
                          <Frame1572_0001>
                            <SelectAProfilePicture>
                              or Upload Profile Picture
                            </SelectAProfilePicture>
                          </Frame1572_0001>
                        </Frame1572>
                        <PRTNR.FileInput
                          label={"Upload Image"}
                          required={true}
                          helpText={"JPG, GIF or PNG. Max size 800K"}
                          accept=".jpg,.jpeg,.gif,.png"
                          onChange={(e) => {
                            if (e) {
                              handleFieldChange("profile_picture", e);
                            } else {
                              console.log("No file selected");
                            }
                          }}
                        />
                      </>
                    </Profilepicture>
                  </Frame1501_0001>
                  <Frame1500>
                    <PRTNR.Button
                      variant="gray-light"
                      onClick={() => {
                        setEditMember(member);
                        goBack();
                      }}
                    >
                      Discard
                    </PRTNR.Button>

                    <Frame1399>
                      <PRTNR.Button
                        variant="black"
                        onClick={() => {
                          updateProfilePicture();
                        }}
                      >
                        {isLoading ? "Saving..." : "Save Changes"}
                      </PRTNR.Button>
                    </Frame1399>
                  </Frame1500>
                </Frame1502_0001>
              </Frame1501>
            )}
            {activeItem == "password" && (
              <Frame1501>
                <Frame1496>
                  <Frame1502>
                    <PRTNR.Input
                      label="Old Password"
                      type={showPassword ? "text" : "password"}
                      icon={showPassword ? OutlineEye : OutlineEyeOff}
                      onIconClick={() => setshowPassword(!showPassword)}
                      value={oldPassword}
                      onChange={(e) => {
                        setOldPassword(e.target.value);
                      }}
                    />
                  </Frame1502>
                  <Frame1502>
                    <PRTNR.Input
                      label="New Password"
                      value={newPassword}
                      type={showNewpass ? "text" : "password"}
                      icon={showNewpass ? OutlineEye : OutlineEyeOff}
                      onIconClick={() => setshowNewpass(!showNewpass)}
                      onChange={(e) => {
                        setNewPassword(e.target.value);
                      }}
                    />
                  </Frame1502>
                  <Frame5_0002>
                    <ErrorDisplay
                      error={passwordError}
                      onClear={() => setPasswordError("")}
                    />
                  </Frame5_0002>
                </Frame1496>
                <Frame1500>
                  <PRTNR.Button
                    variant="gray-light"
                    onClick={() => {
                      setOldPassword("");
                      setNewPassword("");
                      goBack();
                    }}
                  >
                    Discard
                  </PRTNR.Button>

                  <Frame1399>
                    <PRTNR.Button
                      variant="black"
                      onClick={() => {
                        handlePassword();
                      }}
                    >
                      {isLoading ? "Saving..." : "Save Changes"}
                    </PRTNR.Button>
                  </Frame1399>
                </Frame1500>
              </Frame1501>
            )}
            {activeItem == "bank-details" && (
              <PaymentDetails discardOnclick={goBack} />
            )}
          </Frame1502>
        </Wrapper>
      </Dashboard>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        <ModalProfilethree isOpen={isModalOpen} onClose={closeModal} />
      </GenericModal>
      <GenericModal
        isOpen={isSuccessModalOpen}
        onClose={() => {
          closeSuccessModal();
          setMemberUpdated(true);
        }}
      >
        <ModalUpdateSuccess
          isOpen={isSuccessModalOpen}
          onClose={() => {
            closeSuccessModal();
            setMemberUpdated(true);
          }}
        />
      </GenericModal>
    </RootWrapperProfileone>
  );
}

const RootWrapperProfileone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  background: rgb(241, 245, 249);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding-inline: clamp(16px, 2.5vw, 60px);
  flex-shrink: 0;
  /* min-height: 966px; */
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-sizing: border-box;
  padding: 16px 0px;
  flex-shrink: 0;
  width: 100%;
  max-width: 1200px;
`;

const Frame1503 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 31px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1466 = styled.div`
  display: flex;
  padding: var(--Padding-Normal, 16px) var(--Padding-Big, 24px);
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: var(--Color-mics-acent-color-1---Light, rgba(89, 84, 222, 0.1));
`;
const Frame1428 = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 999px;
  background: var(--Color-mics-acent-color-1---Light, rgba(89, 84, 222, 0.1));
`;
const Frame1468 = styled.div`
  display: flex;
  align-items: center;
  gap: var(--Padding-Normal, 16px);
  flex: 1 0 0;

  p {
    color: var(--Color-mics-acent-color-1, #5954de);

    /* P1 - bold */
    font-family: Montserrat;
    font-size: var(--Fonts-P1, 20px);
    font-style: normal;
    font-weight: 700;
    line-height: 160%; /* 32px */
  }
`;

const Frame1494 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 4px;
  width: 1016px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const JamesDoe = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(22px, 2vw, 30px);
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
`;

const IndividualMember = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2.5vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const MemberSince01Mar2025 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(14px, 2vw, 18px);
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Frame1502 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Frame5_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 4px;
  width: 738px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const GeneralInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const BusinessInformation = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
`;

const Frame1501 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  flex: 1;
  gap: 21px;
  width: 886px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1496 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame1502_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-end;
  gap: 21px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1501_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border: solid 1px rgb(225, 228, 233);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Profilepicture = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1572 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1572_0001 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 854px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const SelectAProfilePicture = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: left;
  width: 856px;
  flex: 1;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1570 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 40px 0px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Picture = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 8px;
  border: solid 2px rgba(66, 149, 254, 0.7);
  border-radius: 220px;
  box-sizing: border-box;
  padding: 8px;
`;

const Image21 = styled.img`
  width: 120px;
  height: 120px;
`;

const Frame1500 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 17px;
  box-sizing: border-box;
`;

const Frame1399 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;
